let resizeTimeout;

function Tabs() {
  const tabs = Array.from(
    document.querySelectorAll(".c-tabs--anchor, .c-tabs--mobile-accordion"),
  );
  tabs.forEach((parent) => {
    setupTabs(parent);

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => handleResize(parent), 100);
    });
  });
}

function setupTabs(parent) {
  const controls = Array.from(parent.querySelectorAll(".c-tabs__control"));
  const contents = Array.from(parent.querySelectorAll(".c-tab"));
  const persist = parent.dataset.persist === "true";

  if (!controls.length || !contents.length) return;

  controls.forEach((control, index) => {
    const content = contents[index];
    if (!content) return;

    control.setAttribute("role", "tab");
    control.setAttribute(
      "aria-selected",
      control.classList.contains("c-tabs__control--active") ? "true" : "false",
    );
    control.setAttribute("aria-controls", content.id);
    control.id ||= `tab-${index + 1}-tab`;

    content.setAttribute("role", "tabpanel");
    content.setAttribute("aria-labelledby", control.id);
    content.hidden = !content.classList.contains("c-tab--active");

    control.addEventListener("keydown", (e) => handleKeydown(e, controls));
  });

  handleResize(parent);

  controls.forEach((control) => {
    control.addEventListener(
      "click",
      controlClick(controls, contents, persist),
    );
  });

  if (persist && window.location.hash) {
    const control = parent.querySelector(
      '[href="' + window.location.hash + '"]',
    );
    if (control) control.dispatchEvent(new Event("click"));
  }
}

function handleKeydown(event, controls) {
  const key = event.key;
  const current = event.currentTarget;
  let index = controls.indexOf(current);

  if (["ArrowLeft", "ArrowRight", "Home", "End"].includes(key)) {
    event.preventDefault();

    if (key === "ArrowLeft")
      index = (index - 1 + controls.length) % controls.length;
    if (key === "ArrowRight") index = (index + 1) % controls.length;
    if (key === "Home") index = 0;
    if (key === "End") index = controls.length - 1;

    controls[index].focus();
    controls[index].click();
  }
}

function handleResize(parent) {
  const isAccordion = parent.classList.contains("c-tabs--mobile-accordion");
  const isMobile = window.innerWidth <= 880;

  if (parent.dataset.viewMode === (isMobile ? "accordion" : "tabs")) {
    return;
  }

  parent.dataset.viewMode = isMobile ? "accordion" : "tabs";

  if (isAccordion && isMobile) {
    restructureForAccordion(parent);
  } else if (isAccordion && !isMobile) {
    restoreToTabs(parent);
  }
}

function restructureForAccordion(parent) {
  const controlElements = Array.from(
    parent.querySelectorAll(".c-tabs__control"),
  );
  const tabElements = Array.from(parent.querySelectorAll(".c-tab"));

  const controlsElement = parent.querySelector(".c-tabs__controls");
  if (controlsElement) {
    controlsElement.remove();
  }

  controlElements.forEach((control, index) => {
    const content = tabElements[index];
    if (content) {
      const tabWrapper = document.createElement("div");
      tabWrapper.classList.add("c-tabs__content");

      tabWrapper.appendChild(control);
      tabWrapper.appendChild(content);

      parent.appendChild(tabWrapper);
    }
  });
}

function restoreToTabs(parent) {
  const controls = Array.from(parent.querySelectorAll(".c-tabs__control"));
  const contents = Array.from(parent.querySelectorAll(".c-tab"));

  if (!controls.length || !contents.length) return;

  parent.innerHTML = `
    <nav class="c-tabs__controls-wrapper">
      <div class="c-tabs__controls">
        <ul class="c-tabs__controls-list">
          ${controls.map((control) => `<li>${control.outerHTML}</li>`).join("")}
        </ul>
      </div>
    </nav>
    <div class="c-tabs__content">
      ${contents.map((content) => content.outerHTML).join("")}
    </div>
  `;

  setTimeout(() => setupTabs(parent), 0);
}

function scrollToTabsTop(parent) {
  if (!parent) return;
  const rect = parent.getBoundingClientRect();
  const offset = window.pageYOffset + rect.top;

  const stickyOffset = parent.dataset.stickyOffset
    ? parseInt(parent.dataset.stickyOffset, 10)
    : 0;

  window.scrollTo({
    top: offset - stickyOffset,
    behavior: "smooth",
  });
}

function controlClick(controls, contents, persist) {
  return (event) => {
    const control = event.currentTarget;
    const contentId = control.getAttribute("href")?.replace("#", "");
    const content = contents.find((x) => x.id === contentId);

    if (!content) return true;

    event.preventDefault();

    if (persist) {
      history.pushState(null, null, control.getAttribute("href"));
    }

    const isMobile = window.innerWidth <= 880;

    controls.forEach((c) => {
      const isActive = c === control;
      c.classList.toggle("c-tabs__control--active", isActive);
      c.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    contents.forEach((c) => {
      const isActive = c === content;
      c.classList.toggle("c-tab--active", isActive);
      c.hidden = !isActive;
    });

    scrollToTabsTop(
      control.closest(".c-tabs--anchor, .c-tabs--mobile-accordion"),
    );

    if (control.scrollIntoView) {
      control.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
}

export default Tabs;
